import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'
import { Icon, Menu, Skeleton } from 'components/common'
import { routes } from 'config'
import * as styles from './StoreAdminMenu.module.css'
import { useGeneralSettingQuery } from 'lib/graphql/storeadmin'

export const StoreAdminMenu: React.FC = () => {
  const { data, loading } = useGeneralSettingQuery()

  const items = [
    {
      label: <Link to={routes.home}>ホーム</Link>,
      key: 'home',
      icon: <Icon.HomeFilled />,
    },
    // data?.generalSetting.domain === 'saga-arena'
    //   ? {
    //       label: <Link to={'/calendar'}>予約カレンダー</Link>,
    //       key: 'calendarPage',
    //       icon: <Icon.CalendarFilled />,
    //     }
    //   : null,
    {
      label: '予約管理',
      key: 'bookings',
      icon: <Icon.CalendarFilled />,
      children: [
        {
          label: <Link to={routes.bookings}>予約一覧</Link>,
          key: routes.bookings,
        },
        data?.generalSetting.domain === 'saga-arena'
          ? null
          : {
              label: <Link to={routes.bookingsBulk}>一括作成</Link>,
              key: routes.bookingsBulk,
            },
      ],
    },
    {
      label: <Link to={routes.rates}>料金テーブル管理</Link>,
      icon: <Icon.AccountBookFilled />,
      key: routes.rates,
    },
    {
      label: <Link to={routes.products}>施設管理</Link>,
      icon: <Icon.TagFilled />,
      key: routes.products,
    },
    {
      label: '顧客管理',
      key: 'customers',
      icon: <Icon.UserOutlined />,
      children: [
        {
          label: <Link to={routes.customersPersonal}>個人</Link>,
          key: routes.customersPersonal,
        },
        {
          label: <Link to={routes.customersCorporate}>法人・団体</Link>,
          key: routes.customersCorporate,
        },
        {
          label: <Link to={routes.customersUnRegister}>利用情報未登録</Link>,
          key: routes.customersUnRegister,
        },
      ],
    },
    {
      label: <Link to={routes.discounts}>ディスカウント</Link>,
      icon: <Icon.PropertySafetyOutlined />,
      key: routes.discounts,
    },
    {
      label: '分析',
      icon: <Icon.FundFilled />,
      key: 'analysis',
      children: [
        {
          label: <Link to={routes.analysisSchedule}>利用予定表</Link>,
          key: routes.analysisSchedule,
        },
        {
          label: <Link to={routes.analysisReport}>売上レポート</Link>,
          key: routes.analysisReport,
        },
      ],
    },
    {
      label: '現金出納管理',
      key: 'ledgers',
      icon: <Icon.MoneyCollectFilled />,
      children: [
        {
          label: <Link to={routes.ledgers}>現金出納</Link>,
          key: routes.ledgers,
        },
        {
          label: <Link to={routes.ledgerItems}>項目</Link>,
          key: routes.ledgerItems,
        },
      ],
    },
    {
      label: '設定',
      key: 'settings',
      icon: <Icon.SettingFilled />,
      children:
        data?.generalSetting.domain === 'saga-arena'
          ? [
              {
                label: <Link to={routes.settingsGeneral}>一般設定</Link>,
                key: routes.settingsGeneral,
              },
              {
                label: <Link to={routes.settingsHolidays}>祝日設定</Link>,
                key: routes.settingsHolidays,
              },
              {
                label: <Link to={routes.settingsArena}>アリーナ予約設定</Link>,
                key: routes.settingsArena,
              },
              {
                label: (
                  <Link to={'/admin/settings/calendar'}>予約リスト設定</Link>
                ),
                key: 'calendarPage',
                // icon: <Icon.CalendarFilled />,
              },
            ]
          : [
              {
                label: <Link to={routes.settingsGeneral}>一般設定</Link>,
                key: routes.settingsGeneral,
              },
              {
                label: <Link to={routes.settingsHolidays}>祝日設定</Link>,
                key: routes.settingsHolidays,
              },
            ],
    },
  ]

  if (loading) return <Skeleton />

  return (
    <>
      <div className={clsx(styles.container)}>
        <Menu
          className={clsx(styles.menu)}
          mode="inline"
          items={items}
          defaultSelectedKeys={['home']}
        />
      </div>
    </>
  )
}

export default StoreAdminMenu
